import React from "react";
import Hero from "../components/Hero";
import HeroImage from "../../assets/images/New8.jpg";
import "../../css/BlogGrid.css";
import Button from "../components/Button";
import Blog1 from "../../assets/images/Blog 1.png";
import Blog2 from "../../assets/images/Blog 2.png";
import Blog3 from "../../assets/images/Blog 3.png";
import Blog4 from "../../assets/images/Blog 4.png";

const blogs = [
  {
    title: "What does the McCloud pension ruling mean for me?",
    image: Blog1,
    url: "/blogs/1",
  },
  {
    title:
      "Navigating the £100,000 Childcare Cap: What NHS Consultants Need to Know",
    image: Blog2,
    url: "/blogs/2",
  },
  {
    title: "What Would Happen If I Could No Longer Work As A Medic?",
    image: Blog3,
    url: "/blogs/3",
  },
  {
    title: "I Don’t Want My Working Life Controlling My Life",
    image: Blog4,
    url: "/blogs/4",
  },
  { title: "To Go Limited Or To Not Go Limited", image: Blog1, url: "/blogs/5" },
  {
    title:
      "Private Practice First Steps: A Business and Financial Framework for Doctors",
    image: Blog2,
    url: "/blogs/6",
  },
  { title: "If I Were Starting Private Practice Again…", image: Blog3, url: "/blogs/7" },
  {
    title:
      "Increasing Revenue From Established Referrers in UK Private Practice",
    image: Blog4,
    url: "/blogs/8",
  },
  { title: "Investing – Keep It Simple, Stupid", image: Blog1, url: "/blogs/9" },
  {
    title:
      "Outcomes data is fast becoming the currency of trust in private healthcare",
    image: Blog2,
    url: "/blogs/10",
  },
  {
    title: "What 65 Doctors Told Me About Retirement Planning",
    image: Blog3,
    url: "/blogs/11",
  },
];

const BlogsPage = () => {
  return (
    <div className="about-us-page">
      <Hero title="Blogs" backgroundImage={HeroImage} />
      <div className="primary-background-container-content">
        <h2 className="light">Stay up to date</h2>
      </div>
      <div className="blog-grid">
        {blogs.map((blog) => (
          <a className="blog-card" href={blog.url} key={blog.title}>
            <img
              className="blog-card-image"
              src={blog.image}
              alt={blog.title}
            />
            <div className="blog-card-content">
              <h3 className="blog-card-title">{blog.title}</h3>
                    <p className="blog-card-summary">{blog.summary}</p>
                    <Button text="READ MORE" variant="primary" />
                    
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default BlogsPage;
